<template>
  <div class="detail">
    <NavBar
      :title="$t('articleDetail.title')"
      :routeUrl="'/article'"
    />
    <div class="detail-page">
      <div class="detail-title">{{ info.title }}</div>
      <div class="detail-update">{{ info.updated_at }}</div>
      <div class="detail-content" v-html="info.content"></div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
export default {
  name: "detail",
  mixins: [],
  components: { NavBar },
  props: {},
  data() {
    return {
      article_id: "",
      info: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    getData() {
      this.article_id = this.$route.query.id ? this.$route.query.id : "";
      let params = {
        article_id: this.article_id,
      };
      this.$http.post("/api/v2/article", params).then((res) => {
        if (res.code === 200) {
          this.info = res.data.info;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.detail {
  height: 100%;
}
.detail-page {
  height: auto;
  background-color: #fff;
  padding: 65px 15px 20px;
  text-align: left;
  box-sizing: border-box;
}
.detail-title {
  font-size: 20px;
  font-weight: 700;
}
.detail-update{
  font-size: 12px;
  color: gray;
  margin: 10px 0;
}
.detail-content {
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 1.5;
  padding: 20px 0;
  text-align: justify;
}
</style>
